import Vue from "vue";
import CampaignTemplatesTable from "../components/tables/CampaignTemplatesTable";
import swal from "sweetalert2";

Vue.component('campaign-templates', {
    components: {CampaignTemplatesTable},
    data() {
        return {};
    },
    methods: {},
    props: {
        error_message: {
            type: String,
            required: false
        },
    },
    mounted() {
        if (this.error_message && this.error_message.length > 0) {
            swal.fire({
                title: 'UhOh!',
                text: this.error_message,
                type: 'error',
                confirmButtonText: 'Ok',
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-lg btn-primary'
            });
        }
    },
});
